import React from "react";

import { StyledSearch, StyledSearchIcon } from './search.style';
import { IconButton } from "@mui/material";
import { IStyledSVGIconProps } from "../Icon/icon.style";
export interface ISearchProps {
  onSearch?: any,
  keywords?: string,
  onChange?: any,
  placeholder: string,
  startIcon?: string,
  endIcon?: React.FC<IStyledSVGIconProps>,
  hasAnimation: boolean,
  searchIconLabel?: string,
}
const SearchBox = ({
    onSearch,
    keywords,
    onChange,
    placeholder = "",
    startIcon,
    endIcon: EndIcon,
    hasAnimation,
    searchIconLabel,
    ...props
}: ISearchProps) => {
  const [searchSelected, setSearchSelected] = React.useState(false);
  const [isActiveSearch, setActiveSearch] = React.useState(false);
  const isMobileMode = window.screen.width < 768;
  
  return (
    <StyledSearch
      name="search"
      value={keywords || ""}
      id="txt-searchbox-globalsearch"
      placeholder={placeholder}
      className={hasAnimation ? (isActiveSearch || keywords ? "active-search" : "textField"): "default-search"}
      onMouseOver={() => {
        if (!isMobileMode && hasAnimation)
          setActiveSearch(true);
      }}
      onMouseOut={() => {
        if (!isMobileMode && hasAnimation)
          setActiveSearch(false);
      }}
      InputProps={{
        classes: {
          notchedOutline: "notchedOutline",
        },
        startAdornment: startIcon && (
          <img src={startIcon} className="startIcon" alt="" title="Start Icon" />
        ),
        endAdornment: EndIcon && (
          <IconButton onClick={() => onSearch()} disableRipple={true} aria-label={searchIconLabel}>
            <EndIcon className={`endIcon ${
                searchSelected
                  ? "forwardIconWithBlueColor"
                  : "forwardIconWithGrayColor"
              }`}
              alt=""   />
          </IconButton>
        )
      }}
      onChange={(e) => {
        setSearchSelected(e.target.value === "" ? false : true);
        onChange(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") onSearch();
      }}
      variant="outlined"
      inputProps={{
        "aria-label": placeholder
      }}
    />
  );
};


SearchBox.defaultProps = {
  onSearch: () => { },
  keywords: "",
  onChange: () => { },
  placeholder: "",
  startIcon: "",
  endIcon: StyledSearchIcon,
  hasAnimation: true
};

export default SearchBox;